import { useCallback } from 'react';
import { useApiKeysApi } from '../api';
import { GetApikeyPermissionsParams, GetApikeysParams } from '../types';

export const useApiKeysService = () => {
  const api = useApiKeysApi();

  const getApikeys = useCallback(async (params: GetApikeysParams) => {
    const response = await api.getApikeys(params);
    return response.data;
  }, []);

  const getApikeyPermissions = useCallback(async (params: GetApikeyPermissionsParams) => {
    const response = await api.getApikeyPermissions(params);
    return response.data;
  }, []);

  return {
    getApikeys,
    getApikeyPermissions,
  };
};
